import * as tslib_1 from "tslib";
import { Topology } from '@wix/wixstores-client-core/dist/es/src/constants';
import { MediaFrameMediaType, } from '../types/types';
import { query as getDataQueryString } from '../graphql/getData.graphql';
var DataApi = /** @class */ (function () {
    function DataApi(siteStore) {
        this.siteStore = siteStore;
        //
    }
    DataApi.prototype.getInitialData = function (externalId, compId, limit) {
        var data = {
            query: getDataQueryString,
            source: 'WixStoresWebClient',
            operationName: 'getData',
            variables: { externalId: externalId || '', compId: compId, limit: limit },
        };
        return this.siteStore.httpClient.post(this.siteStore.resolveAbsoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL), data);
    };
    DataApi.prototype.getProducts = function (fromIndex, toIndex, filters, collectionIds, sorting) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestBody;
            return tslib_1.__generator(this, function (_a) {
                requestBody = {
                    viewName: 'StoreFrontFilteredCategoryProductsView',
                    params: {
                        limit: {
                            from: fromIndex,
                            to: toIndex,
                        },
                        filters: filters,
                        categories: collectionIds,
                    },
                };
                if (sorting && sorting.field && sorting.direction) {
                    requestBody.params.sort = { field: sorting.field, direction: sorting.direction };
                }
                return [2 /*return*/, this.siteStore.httpClient
                        .post(this.siteStore.resolveAbsoluteUrl('/wix-ecommerce-storefront-web/catalog/view'), requestBody)
                        .then(function (res) {
                        var products = res.data.products.map(function (p) {
                            return tslib_1.__assign({}, p, { isInStock: p.inventoryStatus === 'in_stock', options: p.isOptionMandatory ? [{ id: 'dummy' }] : [], digitalProductFileItems: p.digitalProductFilesTypes.map(function (type) { return ({
                                    fileType: MediaFrameMediaType[type.toLowerCase()],
                                }); }) });
                        });
                        return {
                            id: '',
                            productsWithMetaData: { list: products, totalCount: res.data.totalCount },
                        };
                    })];
            });
        });
    };
    return DataApi;
}());
export { DataApi };
//# sourceMappingURL=dataApi.js.map